'use client';

import Link from 'next/link';
import WideLogo from 'public/wide-logo.png';

import CommonLanguageSelector from '@/components/common/LanguageSelector';
import { cn } from '@/lib/utils';

interface IProps {
  isProductPage?: boolean;
}
export default function Banner({ isProductPage }: IProps) {
  return (
    <header
      id='banner'
      className={cn('relative w-full border-b border-[#E9ECEF]', !isProductPage && 'bg-white')}
    >
      <div className='relative z-10 mx-auto flex w-full max-w-7xl items-center justify-between gap-2 px-5 py-1'>
        <Link href='/'>
          <img
            src={WideLogo.src}
            alt='Wonder Round'
            className='h-auto w-full min-w-28 max-w-44 opacity-90'
          />
        </Link>

        <CommonLanguageSelector isBanner />
      </div>
    </header>
  );
}
